import { Component } from 'js/lib/components/component'

class CoverFees extends Component {
  initialize() {
    this.feeRate = parseFloat(this.element.dataset.feeRate) || 0.026
    this.feeFlat = parseFloat(this.element.dataset.feeFlat) || 0.37
    this.label = this.element.querySelector('.js-c-cover-fees__label')
    this.form = this.element.closest('form')
    this.checkbox = this.element.querySelector('.js-c-form-input-checkbox')

    if (!this.form) return

    // Allow clicking on the label to toggle the checkbox
    if (this.label && this.checkbox) {
      this.label.style.cursor = 'pointer'
      this.label.addEventListener('click', () => {
        const button = this.checkbox.querySelector('.js-c-form-input-checkbox__button')
        if (button) button.click()
      })
    }

    // Listen for amount changes on any input with 'amount' in the name
    this.form.addEventListener('change', (e) => {
      if (e.target.name?.includes('amount')) {
        this.updateFeeDisplay()
      }
    })

    // Also listen for input events on amount fields (e.g. custom amount typing)
    this.form.addEventListener('input', (e) => {
      if (e.target.name?.includes('amount')) {
        this.updateFeeDisplay()
      }
    })

    // Set initial state
    this.updateFeeDisplay()
  }

  getSelectedAmount() {
    if (!this.form) return 0

    const formData = new FormData(this.form)
    const raw = formData.get('amount')
    if (!raw) return 0

    const value = parseInt(raw, 10)
    return (!isNaN(value) && value > 0) ? value : 0
  }

  calculateFee(amount) {
    if (!amount || amount <= 0) return 0
    return amount * this.feeRate + this.feeFlat
  }

  updateFeeDisplay() {
    const amount = this.getSelectedAmount()
    const fee = this.calculateFee(amount)

    if (this.label) {
      if (fee > 0) {
        this.label.textContent = `Add $${fee.toFixed(2)} to cover processing fees`
      } else {
        this.label.textContent = `Cover processing fees`
      }
    }
  }
}

CoverFees.register('.js-c-cover-fees')

export { CoverFees }
